export default (eventName, props) => {
    if (typeof window === "undefined")
        return;
    const commonProps = {
        channel: props.floor,
        pageName: `as seen on me${props.pageNumber ? `: page ${props.pageNumber}` : ""}`,
        prop31: props.loginStatus,
        eVar10: props.customerId,
    };
    if (!props.status) {
        props.status = "500";
        props.breadcrumb = "as-seen-on-me";
        props.errorMessage = "Request failed with status code 500";
    }
    const config = {
        "ugc-page-load": {
            linkVars: {
                prop4: `${props.floor}~as seen on me`,
                prop8: "as seen on me",
                eVar60: "ugc asom page",
                eVar61: "ugc asom page",
                ...commonProps,
                ...props.conditionalProps,
            },
        },
    };
    return config[eventName];
};
